// 确认订单
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import { Card, Button, Radio, Popup } from 'antd-mobile'
import { AddressEntry } from '../../Address/AddressEntry'
import { Container, Header, Wrapper, Footer } from '../../../components_renew/Layout'
import { YenSpan } from '../../../components_renew/common/YenSpan'
import { ConfirmButton } from '../../../components_renew/Mall/Buttons'
import { OrderConfirmItem } from './ConfirmItem'
import { filterCouponWithProductId } from '../../../utils/filterTicketWithProduct'
import { setOrderConfirmCoupon, setOrderConfirmData, setOrderListRefresh } from '../../../actions/mallAction'
import { requestCouponData } from '../../../actions/couponAction'
import { handleCatch } from '../../../utils'

// let { RadioItem } = Radio

@connect(state => {
    let { addressData, couponData, mallOrderConfirm } = state
    return {
      addressData: addressData.selectedAddress,
      mallCoupon: couponData.mallCoupon,
      commonCoupon: couponData.commonCoupon,
      ...mallOrderConfirm
    }
  }
)
@withRouter
class OrderConfirm extends React.PureComponent {

  loading = false
  // render里productList.map()时进行计算，不再每次state或者props更改时判断是否重新计算
  total = 0
  pendingData = []

  state = {
    // ？
    // total: 0,
    // pendingData: [],
    // idMapCoupon: {}, // ? 无用?

    // modal
    modalVisible: false,
    commonVisible: false,
    // // 通用券列表
    // ticketCommonList: [],
    // ticketCommonSelect: { couponId: '', couponDesc: '不使用' },
    // 判断是否选用了通用券
    isCommon: Boolean(this.props.selectedCommonCoupon['value']),

    productList: this.props.productList,

    // 默认的通用券选项
    selectedCommonCoupon: this.props.selectedCommonCoupon,

    // 商品Id(非productId)对应couponItem的map
    // 该对象才是控制哪个商品选择了哪个券，如直接下单里跳转过来，可直接通过该对象控制页面里选择了哪张券
    selectedCouponMap: this.props.selectedCouponMap, // {id: couponItem}

    // 通用券列表在store里
    // 零售券列表，在mount和update时筛选出对应的couponMap
    productCouponList: [],

    // 当前product下选择的couponId
    selectedCouponId: '',
    // 当前modal的productId
    currentProductId: ''
  }

  componentDidMount () {
    let { productList } = this.props
    if (!(productList.length > 0)) {
      // 若无商品详情，先去获取
      this.props.dispatch(setOrderConfirmData({
        productList: JSON.parse(localStorage.getItem('productList')),
        selectedCouponMap: JSON.parse(localStorage.getItem('selectedCouponMap'))
      }))
    } else {
      // 若有商品，则去匹配对应的券
      let { productList } = this.handleCoupon()
      this.setState({ productList })
    }
    // 若无券信息，则去获取券
    if (!(this.props.mallCoupon.length > 0) || (this.props.commonCoupon.length > 0)) {
      this.props.dispatch(requestCouponData())
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if ((prevProps.productList !== this.props.productList) || (prevProps.mallCoupon !== this.props.mallCoupon)) {
      // 若商品改变，重新筛选券
      let { productList } = this.handleCoupon()
      this.setState({ productList })
    }
  }

  componentWillUnmount () {
    // 只为退出该页面时记录一下券的状态，以便返回或者跳去选择地址时不用重新选择
    this.props.dispatch(setOrderConfirmCoupon({
      selectedCommonCoupon: this.state.selectedCommonCoupon,
      selectedCouponMap: this.state.selectedCouponMap
    }))
  }

  handleCoupon = () => {
    // 筛选出哪个商品能用哪个票
    let productList = this.props.productList.map((item) => {
      let couponList = filterCouponWithProductId(item['productId'], this.props.mallCoupon)
      if (couponList.length > 0) {
        Object.assign(item, { couponUsable: true, couponList })
      }
      return item
    })
    return { productList }
  }

  render () {
    let { commonCoupon } = this.props

    let {
      modalVisible,
      commonVisible,
      selectedCommonCoupon,
      selectedCouponId,
      productCouponList
    } = this.state
    // console.group('Confirm render')
    // console.log(productCouponList)
    // console.log(selectedCouponId)
    // console.log(this.state)
    // console.groupEnd()

    let { productList, total, amount } = this.handlePendingData()
    return <Container>
      <Header>确认订单</Header>
      <Wrapper flex>
        <AddressEntry/>
        <br/>
        <div>
          {productList}
          {/*  通用券*/}
          {
            // commonCoupon.length > 0 &&
            // <Card style={{ minHeight: 'unset' }} className={'item-card item-card--margin-bottom'}>
            //   <Card.Header title={'通用券'} />
            //   <Card.Body style={{ minHeight: 'unset' }}>通用券与商品折扣券只能同时使用其中一种<br />通用券按整张订单价格进行折扣</Card.Body>
            //   <Card.Footer onClick={this.onCommonClick} extra={<div className='item-card__extra'><i
            //     className={'icon-font icon-arrow-down-bold'} /> {selectedCommonCoupon['couponDesc']}
            //   </div>} />
            // </Card>
            commonCoupon.length > 0 &&
            <Card className={'!rounded-none'}>
              <div className={'leading-loose font-bold border-b'}>通用券</div>
              <div className={'text-xs text-secondary my-4'}>
                通用券与商品折扣券只能同时使用其中一种
                <br/>
                通用券按整张订单价格进行折扣
              </div>
              {/*<Card.Footer onClick={this.onCommonClick} extra={<div className="item-card__extra"><i*/}
              {/*  className={'icon-font icon-arrow-down-bold'}/> {selectedCommonCoupon['couponDesc']}*/}
              {/*</div>}/>*/}
              <div className={'flex justify-end mb-8'}>
                <Button color={'primary'} fill={'outline'} size={'mini'} onClick={this.onCommonClick}>
                  <i className={'icon-font icon-arrow-down-bold'}/>&emsp;
                  {selectedCommonCoupon['couponDesc']}
                </Button>
              </div>
            </Card>
          }
        </div>
      </Wrapper>
      <Footer className={'justify-between'}>
        <div style={{ padding: '1rem' }}>
          <span>共 {amount} 件&emsp;合计： </span>
          <YenSpan>{total}</YenSpan>
        </div>
        <ConfirmButton type={'danger'} onClick={this.confirmOrder}>&emsp;提交订单&emsp;</ConfirmButton>
      </Footer>
      {/*折扣券*/}
      <Popup
        visible={modalVisible}
        onClose={this.closeModal}
        showCloseButton
        closeOnMaskClick
        bodyClassName={'p-2'}
      >
        <div className={'text-lg font-bold mb-4'}>请选择折扣券</div>
        <div className={'flex flex-col max-h-[80vh] overflow-y-auto'}>
          <Radio className={'mb-4'}
                 checked={selectedCouponId === ''}
                 onChange={this.onCouponPickerChange.bind(this, { couponId: '', couponDesc: '不使用' })}>
            不使用
          </Radio>
          {productCouponList.map((item, index) => (
            item['used']
              ? null
              : <Radio key={index}
                       className={'mb-4'}
                       checked={item['couponId'] === selectedCouponId}
                       onChange={this.onCouponPickerChange.bind(this, item)}>
                {item['couponDesc']}
              </Radio>
          ))}
        </div>
      </Popup>

      {/*通用券*/}
      <Popup
        visible={commonVisible}
        onClose={this.closeModal}
        showCloseButton
        closeOnMaskClick
        bodyClassName={'p-2'}
      >
        <div className={'text-lg font-bold mb-4'}>请选择通用券</div>
        <div className={'flex flex-col max-h-[80vh] overflow-y-auto'}>
          <Radio className={'mb-4'}
                 checked={selectedCommonCoupon['couponId'] === ''}
                 onChange={this.onCommonTicketChange.bind(this, { couponId: '', couponDesc: '不使用' }, false)}>
            不使用
          </Radio>
          {commonCoupon.map((item, index) => (
            <Radio key={index}
                   className={'mb-4'}
                   checked={item['couponId'] === selectedCommonCoupon['couponId']}
                   onChange={this.onCommonTicketChange.bind(this, item, true)}>
              {item['couponDesc']}
            </Radio>
          ))}
        </div>
      </Popup>
    </Container>
  }

  closeModal = () => this.setState({ modalVisible: false, commonVisible: false })

  onCommonClick = () => {this.setState({ commonVisible: true })}

  onCouponClick = (productItem) => {
    let { couponList, id } = productItem
    let { selectedCouponMap } = this.state
    // 判断券是否在其他商品使用
    let selectedCouponList = []
    let selectedCouponId = ''
    // 有问题
    for (let key in selectedCouponMap) {
      if (selectedCouponMap.hasOwnProperty(key)) {
        // console.log('id === key ?', id, key)
        // console.log(typeof id, typeof key)
        // 我们协定id和key都必须为string
        if (String(id) === String(key)) {
          selectedCouponId = selectedCouponMap[key] ? selectedCouponMap[key]['couponId'] : ''
        } else {
          selectedCouponList.push(selectedCouponMap[key])
        }
      }
    }
    let productCouponList = couponList.map(item => ({
      ...item,
      used: Boolean(selectedCouponList.find(i => i['couponId'] === item['couponId']))
    }))
    this.setState({
      modalVisible: true,
      currentProductId: id,
      productCouponList,
      selectedCouponId
    })
  }

  onCouponPickerChange = coupon => {
    if (coupon['used']) return
    let selectedCouponMap = _.cloneDeep(this.state.selectedCouponMap)
    // let selectedCouponMap = {...this.state.selectedCouponMap}
    let { currentProductId } = this.state
    selectedCouponMap[currentProductId] = coupon['couponId'] ? coupon : undefined
    this.setState({ selectedCouponMap, selectedCouponId: coupon['couponId'], modalVisible: false })
  }

  onCommonTicketChange = (coupon, isCommon) => {
    this.setState({ selectedCommonCoupon: coupon, isCommon })
  }

  handlePendingData = () => {
    let { isCommon, selectedCouponMap, selectedCommonCoupon, productList } = this.state
    let total = 0
    let amount = 0
    let pendingData = []
    if (isCommon) {
      // 处理使用通用券的逻辑
      productList = productList.map((item, key) => {
        let { currentPrice, productCount, id, index, state } = item
        let pendingItem = {
          productCount,
          productId: id,
          // 这几个并非必传，传了是为了服务端将商品从购物车中剔除？
          id: index ? index : undefined,
          state: state ? state : undefined
        }
        let price = Number(currentPrice) * productCount
        total += price
        amount += productCount
        pendingData.push(pendingItem)
        return <OrderConfirmItem key={key} {...item}
                                 isCommon={isCommon}
                                 couponData={selectedCouponMap[item['id']]}
                                 onCouponClick={this.onCouponClick.bind(this, item)}/>
      })
      let count = Number(selectedCommonCoupon['price'])
      total -= count
      if (total < 0) total = 0
    } else {
      // 处理使用零售券的逻辑
      productList = productList.map((item, key) => {
        let { id, index, state, currentPrice, productCount } = item
        let pendingItem = {
          productCount,
          productId: id,
          id: index ? index : undefined,
          state: state ? state : undefined
        }
        // 一张券只能用一种商品
        let price = Number(currentPrice) * productCount
        if (selectedCouponMap[id]) {
          let value = Number(selectedCouponMap[id]['price'])
          price = price - value
          if (price < 0) { price = 0}
          Object.assign(pendingItem, {
            couponFlag: 1,
            couponId: selectedCouponMap[id]['couponId']
          })
        }
        amount += productCount
        total += price
        pendingData.push(pendingItem)
        return <OrderConfirmItem key={key} {...item}
                                 isCommon={isCommon}
                                 couponData={selectedCouponMap[item['id']]}
                                 onCouponClick={this.onCouponClick.bind(this, item)}/>
      })
    }
    // 处理完券的计算后，设置this.total, this.pendingData以备confirm时使用
    this.total = total
    this.pendingData = pendingData

    // 输出要渲染的productList和amount
    return { productList, amount, total }
  }

  // 结算
  confirmOrder = () => {
    let { addressData } = this.props
    let { isCommon, selectedCommonCoupon } = this.state

    if (!addressData || !addressData['id']) {
      window.toast.info('请选择收获地址', 1)
      return
    }
    window.toast.show('下单中...')
    let config = {
      method: 'post',
      url: window.API.Mall.postOrder,
      data: {
        address: {
          id: addressData['id'],
          flag: addressData['flag'],
          isDefault: addressData['isDefault'],
          region: addressData['region'],
          receivingAddress: addressData['address'],
          receivingMobile: addressData['phone'],
          receivingName: addressData['name']
        },
        carList: this.pendingData,
        couponFlag: isCommon ? 1 : 0,
        couponId: isCommon ? selectedCommonCoupon['couponId'] : '',
        totalPrice: this.total
      }
    }
    window.toast.hide()
    window.axios.request(config)
      .then(orderId => {
        window.toast.success('下单成功', 1, () => {
          this.props.dispatch(setOrderListRefresh())
          this.props.history.replace(`${window.PATH.MALL_ORDER_PAY}/${orderId}`)
        })
      })
      .catch(handleCatch)
    // .finally(() => this.loading = false)
  }
}

export { OrderConfirm }
